export default __webpack_public_path__ + "4534b9d343b4d64632f4044a789105d3.png";